import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { Select } from "components/Select/Select";
import { useTranslate } from "hooks";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";
import { InputList } from "./InputList";
import s from "../../ProductConfiguratorComponent.module.scss";

export const TechnicalDesignInputs = Scrivito.connect(
  ({
    strategyOptions,
    handleSelectStrategy,
    selectedOption,
    productConfiguration,
    inputs,
    isDisabled = false,
  }) => {
    const translate = useTranslate();

    const { changeProduct } = useProductConfiguratorStore.use.actions();

    return (
      <>
        <div className="border-bottom px-4 pb-2">
          <h5 className="mb-2 font16">
            {translate("PRODUCT_CONFIGURATOR_STRATEGY")}
          </h5>
          <Select
            name={"strategy-select"}
            data-recording-disable={true}
            options={strategyOptions}
            onChange={handleSelectStrategy}
            isDisabled={isDisabled}
            value={selectedOption}
            testId={productConfiguration?.id}
            className="font-md"
          />
        </div>
        <div className="position-relative px-4">
          <InputList
            list={inputs}
            isValueEditable={!isDisabled}
            onChange={changeProduct}
            headerStyles="font-md py-2 mb-0"
            propertyStyles={cx("pb-2 font-md", s.cardInputRow)}
          />
        </div>
      </>
    );
  },
);
